exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clientActionsAdd{background:#efecec}.clientActionsAdd .client-action-add{margin-top:40px}.clientActionsAdd .floating-panel{-webkit-box-shadow:-4px 5px 6px -3px rgba(0,0,0,.16);box-shadow:-4px 5px 6px -3px rgba(0,0,0,.16);border-radius:3px;background:#fff;margin-bottom:100px}.clientActionsAdd .floating-panel .multiselect__tags{padding-right:50px}.clientActionsAdd .floating-panel .multiselect__content-wrapper .multiselect__element span{white-space:normal}.clientActionsAdd .vue-dropzone .dz-preview .dz-details,.clientActionsAdd .vue-dropzone .dz-preview .dz-remove{z-index:auto}", ""]);

// exports
